import * as Sentry from '@sentry/react';

import config from 'config';
import apiCall from 'shared/utils/apiCall';
import apolloClient from 'store/apolloClient';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';
import { getCurrentLanguage } from 'modules/language/selectors/language';

import createAction from './';
import * as services from '../services/login';

export const LOGIN = createAsyncAction(createAction('LOGIN'));

export const login = (data, isExtendedLogin, captchaToken) => (dispatch, getState) => {
  dispatch({ type: LOGIN.pending });

  const state = getState();

  const orgId = state.auth.organizations.selectedOrganizationToken || Number(config.org_id);
  const locale = getCurrentLanguage();

  const apiCallParams = {
    mutation: !isExtendedLogin ? services.LOGIN : services.SECONDARY_LOGIN,
    variables: {
      ...data,
      orgId,
      captchaToken,
      locale,
    },
  };

  return apiCall(apolloClient.mutate, apiCallParams)
    .then(({ data: { login: { token, phoneNumber } } }) => {
      if (data.externalId) {
        Sentry.configureScope((scope) => {
          scope.setUser({ 'policyId': data.externalId });
        });
      }

      return dispatch({
        type: LOGIN.success,
        payload: {
          policyId: data.externalId,
          secondaryLoginData: data,
          verificationToken: token,
          phoneNumber,
        },
      });
    })
    .catch((err) => {
      dispatch(errorAction(LOGIN.failure, err));
      throw err;
    });
};
